module.exports = __webpack_public_path__ + "static/media/sologo.efb4e2ac.png";